module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp3_3009.c5e9f5f7.png";